var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountHoverstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30793 8.85902C9.47813 8.85902 11.2374 7.09972 11.2374 4.92951C11.2374 2.7593 9.47813 1 7.30793 1C5.13772 1 3.37842 2.7593 3.37842 4.92951C3.37842 7.09972 5.13772 8.85902 7.30793 8.85902Z",
    fill: "#EE7233",
    stroke: "#EE7233",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6158 15.2773C13.6158 17.3455 10.8238 19 7.30789 19C3.79202 19 1 17.3455 1 15.2773C1 14.0364 2.03408 12.4853 3.68861 11.8649C4.72269 11.4512 5.96359 11.5546 7.30789 11.5546C8.6522 11.5546 9.8931 11.3478 10.9272 11.8649C12.4783 12.4853 13.6158 14.0364 13.6158 15.2773Z",
    fill: "#EE7233",
    stroke: "#EE7233",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountHoverstate);
export default __webpack_public_path__ + "static/media/Account _ hover state.06200fb7eae3e802b0107c72c9493769.svg";
export { ForwardRef as ReactComponent };